import { NationalCommitteeDetailRedirect } from "./_NationalCommitteesRedirect";

export default function NationalCommitteeDetailPage() {
  return <NationalCommitteeDetailRedirect />;
}
